import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';
import { createComponent } from '../core/create-component.js';
import { useCollapsibleContext } from './collapsible.context.js';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpreadProps(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
const CollapsibleSummaryButton = createComponent({
  displayName: 'CollapsibleSummaryButton',
  root: 'button',
  propConfig: {
    derivedProps() {
      return useCollapsibleContext();
    },
    processProps(props, derivedProps) {
      const {
        expanded,
        onRequestExpandedChange,
        contentId
      } = derivedProps;
      return _objectSpreadProps(_objectSpread({}, props), {
        onClick: composeEventHandlersUtil(props.onClick, () => onRequestExpandedChange(!expanded)),
        'aria-expanded': expanded,
        'aria-controls': contentId || undefined
      });
    },
    classNames: ['swan-collapsible-summary-button']
  }
});
export { CollapsibleSummaryButton };